import React from "react";
import { formatarMoeda } from "../../../utils/calculos";
import { usePrecosVisiveis } from "../../../context/PrecosContext";
import {
  CriticosTable,
  CriticosTableWrapper,
  CriticosTd,
  CriticosTh,
} from "./styles";

function moeda(valor, mostrar) {
  return mostrar ? formatarMoeda(valor) : "••••••";
}

function pct(value) {
  if (value == null || !Number.isFinite(value)) return "—";
  return `${(value * 100).toFixed(1)}%`;
}

export default function AccountingBridge({ contabil }) {
  const { precosVisiveis } = usePrecosVisiveis();
  const linhas = [
    { sigla: "T", titulo: "Ganho", valor: moeda(contabil.T, precosVisiveis), label: contabil.labels.T },
    { sigla: "I", titulo: "Inventário", valor: moeda(contabil.I, precosVisiveis), label: contabil.labels.I },
    { sigla: "OE", titulo: "Despesa Operacional", valor: moeda(contabil.OE, precosVisiveis), label: contabil.labels.OE },
    { sigla: "Lucro", titulo: "T − OE", valor: moeda(contabil.lucro, precosVisiveis), label: contabil.labels.lucro },
    { sigla: "ROI", titulo: "(T − OE) ÷ I", valor: pct(contabil.ROI), label: contabil.labels.ROI },
  ];

  return (
    <CriticosTableWrapper>
      <CriticosTable>
        <thead>
          <tr>
            <CriticosTh>TOC</CriticosTh>
            <CriticosTh>Fórmula</CriticosTh>
            <CriticosTh $right>Valor</CriticosTh>
            <CriticosTh>Conta contábil correspondente</CriticosTh>
          </tr>
        </thead>
        <tbody>
          {linhas.map((row) => (
            <tr key={row.sigla}>
              <CriticosTd><strong>{row.sigla}</strong></CriticosTd>
              <CriticosTd>{row.titulo}</CriticosTd>
              <CriticosTd $right>{row.valor}</CriticosTd>
              <CriticosTd>{row.label}</CriticosTd>
            </tr>
          ))}
          {(contabil.IPorEtapa || []).length > 0 && (
            <tr>
              <CriticosTd colSpan={4}>
                <strong>I por etapa: </strong>
                {contabil.IPorEtapa.map((linha, idx) => (
                  <span key={linha.etapa}>
                    {linha.label} {moeda(linha.valor, precosVisiveis)}
                    {idx < contabil.IPorEtapa.length - 1 ? " · " : ""}
                  </span>
                ))}
              </CriticosTd>
            </tr>
          )}
        </tbody>
      </CriticosTable>
    </CriticosTableWrapper>
  );
}
